<template>
	<a
		class="news_listing__item"
		v-on:mouseover="mouseover"
		v-on:mouseleave="mouseleave"
		:href="permalink"
	>
		<img
			v-if="background"
			class="background__image"
			:src="background"
			:alt="title"
		/>

		<transition name="slide-fade">
			<div class="overlay" :class="{ hovered: show }"></div>
		</transition>

		<transition name="slide-fade">
			<div class="title_category">
				<h4
					v-for="(cat, index) in category"
					:key="index"
					v-html="cat.name"
				></h4>
				<a :href="permalink"><h3 v-text="title"></h3></a>
				<a :href="permalink"><p class="read_more">Read More &rarr;</p></a>
			</div>
		</transition>
	</a>
</template>

<script>
export default {
	data() {
		return {
			show: false,
		};
	},

	props: {
		title: {
			type: String,
			default: 'This is a News Listing Item',
		},
		permalink: {
			type: String,
			default: '',
		},
		category: {},
		size: {
			type: String,
			default: 'one',
		},
		background: {
			default: require('../../images/dummy_image.jpg'),
		},
	},

	computed: {
		styles: function () {
			return {
				'background-image': 'url(' + this.background + ')',
			};
		},
	},

	watch: {},

	methods: {
		mouseover: function () {
			this.show = true;
		},
		mouseleave: function () {
			this.show = false;
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

[size='one'] {
	grid-column: span 1;

	@media (max-width: $md) {
		grid-column: span 10;
	}
}

[size='two'] {
	grid-column: span 2;

	@media (max-width: $md) {
		grid-column: span 10;
	}
}

[size='three'] {
	grid-column: span 3;

	@media (max-width: $md) {
		grid-column: span 10;
	}
}

.news_listing__item {
	text-decoration: none;
	min-height: 400px;
	background: lighten($edc-charcoal, 20);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	padding: 2rem;
	position: relative;
	overflow: hidden;

	@media (max-width: $md) {
		min-height: 300px;
	}

	&:hover {
		.background__image {
			transition: all 0.2s ease;
			transform: scale(1.1);
		}
	}

	@media (max-width: $md) {
		grid-column: span 10;
	}

	&:nth-child(5n + 2) {
		grid-column: span 2;

		@media (max-width: $md) {
			grid-column: span 10;
		}
	}

	.background__image {
		width: 100%;
		height: 100%;
		z-index: 0;
		transition: all 0.2s ease;
		transform: scale(1);
		object-fit: cover;
	}

	> img {
		position: absolute;
		height: 100%;
		top: 0;
	}

	.title_category {
		position: relative;
		z-index: 20;
		width: 100%;
		transition: all 0.2s ease;
		opacity: 1;
		transform: translateY(0px);

		h3 {
			color: white;
			font-weight: bold;
			font-size: 1.5rem;
			margin: 1rem 0;

			&:hover {
				color: $edc-red;
			}
		}

		h4 {
			color: white;
			font-weight: bold;
			font-size: 1rem;
			margin: 0 0 10px;
		}

		a {
			text-decoration: none;
			color: white;

			&:hover {
				color: $edc-red;
			}

			@media (max-width: $md) {
				max-width: 30px;
			}
		}

		p {
			&.read_more {
				margin: 0 0 2rem;
				font-weight: bold;
				color: $edc-red;
			}
		}
	}

	.overlay {
		background: rgba(0, 0, 0, 0.7);
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
		padding: 2rem;
		width: calc(100% - 4rem);
		height: calc(100% - 4rem);
		position: absolute;
		top: 0;
		transition: 0.2s ease all;

		&.hovered {
			background: rgba(0, 0, 0, 0.9);
		}

		&__plus {
			color: white;
			font-size: 6rem;
			font-weight: 300;
			transition: all 0.2s ease;
			opacity: 1;
			transform: translateY(0px);

			@media (max-width: $md) {
				line-height: 25px;
			}

			img {
				max-width: 60px;

				@media (max-width: $md) {
					max-width: 30px;
				}
			}
		}

		&__excerpt {
			color: white;
			max-width: 50%;
			font-size: 0.75rem;
			text-align: center;
			margin: 1rem 0 2rem;
			line-height: 1.5rem;
		}

		&__button {
			background: $edc-red;
			color: black;
			text-decoration: none;
			padding: 0.5rem 1rem 0.25rem;
			border-radius: 5px;
			text-transform: uppercase;
			font-size: 0.75rem;
			font-weight: bold;
		}
	}
}

.slide-fade-enter-active {
	transition: opacity 0.2s ease;
	// transition-delay: .4s;
}

.slide-fade-leave-active {
	transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1);
	// transition-delay: .4s;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;

	.overlay__plus {
		transform: translateY(-50px);
		opacity: 0;
	}

	.title_category {
		transform: translateY(50px);
		opacity: 0;
	}
}
</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/NewsListingItem.vue